var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { BaseSingletonService, Singleton } from '~/services/service.base';
import { UIOpenService } from '~/services/service.ui';
import { action, makeObservable, observable } from 'mobx';
import { EFileType } from '~/shared/types';
export let ServiceMediaViewer = class ServiceMediaViewer extends BaseSingletonService {
    mediaViewOpenService;
    openedItem;
    openedItemIndex;
    constructor(mediaViewOpenService) {
        super();
        this.mediaViewOpenService = mediaViewOpenService;
        makeObservable(this);
    }
    setOpenedItem(item) {
        this.openedItem = item;
    }
    setOpenedItemIndex(items) {
        this.openedItemIndex = items.findIndex(itemObj => itemObj.id === this.openedItem.id);
    }
    filterMediaItems(items) {
        return items.filter(item => item.fileType === EFileType.image || item.fileType === EFileType.video);
    }
};
__decorate([
    observable,
    __metadata("design:type", typeof (_b = typeof TImageItem !== "undefined" && TImageItem) === "function" ? _b : Object)
], ServiceMediaViewer.prototype, "openedItem", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], ServiceMediaViewer.prototype, "openedItemIndex", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_c = typeof TImageItem !== "undefined" && TImageItem) === "function" ? _c : Object]),
    __metadata("design:returntype", void 0)
], ServiceMediaViewer.prototype, "setOpenedItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], ServiceMediaViewer.prototype, "setOpenedItemIndex", null);
ServiceMediaViewer = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof UIOpenService !== "undefined" && UIOpenService) === "function" ? _a : Object])
], ServiceMediaViewer);
